export const API_DOMAIN = process.env.VUE_APP_API_DOMAIN;

export const STORAGE_KEY_USER_ID = "userId";
export const STORAGE_KEY_USER_NAME = "userName";
export const STORAGE_KEY_USER_PICTURE = "userPicture";
export const STORAGE_KEY_USER_NICK = "userNick";
export const STORAGE_KEY_USER_ROLES = "userRoles";
